import { Link } from "react-router-dom";
import { cx } from "./ui";

type MonitoringView = "setup" | "updates";

const views: readonly { readonly id: MonitoringView; readonly to: string; readonly label: string }[] = [
  { id: "setup", to: "/subscriptions", label: "Source monitoring" },
  { id: "updates", to: "/updates", label: "Update log" },
];

export function MonitoringNav({ active }: { readonly active: MonitoringView }) {
  return (
    <nav aria-label="Monitoring workflow" className="flex gap-5 border-b border-[var(--line)]">
      {views.map((view) => (
        <Link
          key={view.id}
          to={view.to}
          aria-current={active === view.id ? "page" : undefined}
          className={cx(
            "-mb-px border-b-2 px-0.5 py-2.5 text-[13px] font-semibold transition",
            active === view.id
              ? "border-[var(--accent)] text-[var(--accent-dark)]"
              : "border-transparent text-slate-600 hover:border-slate-300 hover:text-slate-800",
          )}
        >
          {view.label}
        </Link>
      ))}
    </nav>
  );
}
